import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";
import { registerDeviceToken } from "../features/notifications/notificationsAPI";

export const usePushNotifications = () => {
  const dispatch = useDispatch();

  const sendDeviceTokenToBackend = async (deviceToken) => {
    try {
      const deviceInfo = await Device.getInfo();
      const platform = deviceInfo.platform.toLowerCase();
      const technicianId = getCurrentTechnicianId();

      if (!technicianId) {
        console.error(
          "No technician ID available, cannot register device token"
        );
        return;
      }

      console.log("Sending device token to backend...", {
        technicianId: parseInt(technicianId),
        token: deviceToken,
        platform: platform,
      });

      dispatch(
        registerDeviceToken(parseInt(technicianId), deviceToken, platform)
      )
        .then(() => {
          console.log("Device token sent to backend successfully");
        })
        .catch((error) => {
          console.error("Failed to send device token to backend:", error);
        });
    } catch (error) {
      console.error("Error sending device token:", error);
    }
  };

  const initializePushNotifications = () => {
    // Only run on mobile platforms (iOS/Android), not web
    localStorage.setItem(
      "CapacitorPlatform",
      Capacitor.platform + Capacitor.isNativePlatform() + Capacitor.isNative
    );

    // console.log(
    //   "CapacitorPlatformlog",
    //   Capacitor.platform,
    //   Capacitor.isNativePlatform(),
    //   Capacitor.isNative
    // );

    if (!Capacitor.isNativePlatform()) {
      console.log("Push notifications only work on mobile devices");
      return;
    }

    console.log("Initializing push notifications...");

    // Request permission
    PushNotifications.requestPermissions().then((result) => {
      if (result.receive === "granted") {
        console.log("Push notification permission granted");
        PushNotifications.register();
      } else {
        console.log("Push notification permission denied");
      }
    });

    // Get device token when registration succeeds
    PushNotifications.addListener("registration", (token) => {
      console.log("Push registration success, token: ", token.value);
      sendDeviceTokenToBackend(token.value);
    });

    // Handle errors
    PushNotifications.addListener("registrationError", (err) => {
      console.error("Push registration error: ", err);
    });

    // Handle notifications received when app is open
    PushNotifications.addListener(
      "pushNotificationReceived",
      (notification) => {
        console.log("Push received: ", notification);
      }
    );

    // Handle notification tap
    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      (notification) => {
        console.log("Push action performed: ", notification);
        if (notification.notification.data?.appointmentId) {
          console.log(
            "Navigate to appointment:",
            notification.notification.data.appointmentId
          );
        }
      }
    );
  };

  const getCurrentTechnicianId = () => {
    const tech = localStorage.getItem("userId");
    return tech;
  };

  return {
    initializePushNotifications,
    sendDeviceTokenToBackend,
  };
};
